<template>
  <v-main fluid>
    <div class="center-center">
      <v-card max-width="500px" elevation="7">
        <v-tabs v-model="active_form">
          <v-tab-item v-for="form in forms" :key="form.index">
            <v-form ref="register" @submit.prevent="submit">
              <v-container fluid>
                <h2>{{ form.name }}</h2>
                <v-row>
                  <!-- FIRST NAME -->
                  <v-col
                    class="pt-0 pb-0"
                    v-if="showField('First_Name')"
                    cols="12"
                    sm="6"
                  >
                    <v-text-field
                      class="center-input"
                      color="grey darken-3"
                      v-model="authForm.First_Name"
                      :rules="rules.name"
                      label="First name"
                      required
                    ></v-text-field>
                  </v-col>
                  <!-- LAST NAME -->
                  <v-col
                    class="pt-0 pb-0"
                    v-if="showField('Last_Name')"
                    cols="12"
                    sm="6"
                  >
                    <v-text-field
                      class="center-input"
                      color="grey darken-3"
                      v-model="authForm.Last_Name"
                      :rules="rules.name"
                      label="Last name"
                      required
                    ></v-text-field>
                  </v-col>
                  <!-- EMAIL -->
                  <v-col class="pt-0 pb-0" cols="12">
                    <v-text-field
                      class="center-input"
                      color="grey darken-3"
                      v-model="authForm.Email"
                      :rules="rules.email"
                      validate-on-blur
                      label="Email Address"
                      required
                    ></v-text-field>
                  </v-col>
                  <!-- PASSWORD -->
                  <v-col
                    class="pt-0 pb-0"
                    v-if="showField('Password')"
                    cols="12"
                  >
                    <v-text-field
                      class="center-input"
                      color="grey darken-3"
                      v-model="authForm.Password"
                      :append-icon="
                        showHide.password ? 'mdi-eye-off' : 'mdi-eye'
                      "
                      @click:append="showHide.password = !showHide.password"
                      :type="showHide.password ? 'password' : 'text'"
                      label="Password"
                      center
                      required
                      v-on:keyup.enter="onEnter('password')"
                    ></v-text-field>
                  </v-col>
                  <!-- CONFIRM PASSWORD -->
                  <v-col
                    class="pt-0 pb-0"
                    v-if="showField('Confirm_Password')"
                    cols="12"
                  >
                    <v-text-field
                      class="center-input"
                      color="grey darken-3"
                      v-model="authForm.Confirm_Password"
                      :rules="rules.password"
                      :type="showHide.password ? 'password' : 'text'"
                      validate-on-blur
                      label="Confirm Password"
                      required
                    ></v-text-field>
                  </v-col>
                  <!-- TERMS AND CONDITIONS -->
                  <v-col class="pt-0 pb-0" v-if="showField('Terms')" cols="12">
                    <v-checkbox
                      v-model="authForm.Terms_Conditions"
                      color="green"
                    >
                      <template v-slot:label>
                        <div @click.stop>
                          I accept the
                          <a
                            href="javascript:;"
                            @click.stop="showHide.terms = true"
                            >terms</a
                          >
                          and
                          <a
                            href="javascript:;"
                            @click.stop="showHide.conditions = true"
                            >conditions</a
                          >.
                        </div>
                      </template>
                    </v-checkbox>
                  </v-col>
                  <!-- RESET EMAIL MESSAGE -->
                  <v-col
                    class="pt-5 pb-0"
                    v-if="showField('Reset_Email_Message')"
                    cols="12"
                  >
                    <v-alert
                      dense
                      color="cyan"
                      border="left"
                      elevation="2"
                      colored-border
                      icon="mdi-lock-reset"
                      >{{
                        $t(
                          "Please enter your email address and a reset password link will be sent to you."
                        )
                      }}</v-alert
                    >
                  </v-col>
                </v-row>
                <!-- ALERT COMPONENT  -->
                <!-- <v-alert dense v-if="alert.show" :type="alert.type">{{
                  $t(alert.message)
                }}</v-alert> -->
              </v-container>
              <!-- // ACTION BUTTONS -->
              <v-card-actions>
                <v-btn text @click="resetForm">Cancel</v-btn>
                <v-spacer></v-spacer>
                <v-btn
                  v-if="active_form == 1"
                  :disabled="!registrationIsValid"
                  text
                  color="primary"
                  @click="_registerUser(authForm)"
                  >{{ $t("register") }}</v-btn
                >
                <v-btn
                  v-if="active_form == 0"
                  :disabled="!signInIsValid"
                  text
                  color="primary"
                  @click="_signIn(authForm)"
                  >{{ $t("SIGN IN") }}</v-btn
                >
                <v-btn
                  v-if="active_form == 2"
                  :disabled="!resetPasswordIsValid"
                  text
                  color="primary"
                  @click="_resetPassword(authForm)"
                  >RESET PASSWORD</v-btn
                >
              </v-card-actions>
            </v-form>
          </v-tab-item>
        </v-tabs>
      </v-card>
      <div class="text-center mt-3">
        <v-btn
          v-if="showField('Create_Account')"
          link
          text
          medium
          color="blue-grey"
          @click="active_form = 1"
          >CREATE ACCOUNT</v-btn
        >
        <v-btn
          v-if="active_form == 0"
          link
          text
          medium
          color="blue-grey"
          @click="active_form = 2"
          >Forgot Password?</v-btn
        >
        <v-btn
          v-if="active_form != 0"
          link
          text
          medium
          color="blue-grey"
          @click="active_form = 0"
          >SIGN IN</v-btn
        >
      </div>
    </div>

    <v-dialog v-model="showHide.terms" width="70%">
      <v-card>
        <v-card-title class="title">Terms</v-card-title>
        <v-card-text>{{ content.terms }}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text color="blue" @click="showHide.terms = false">Ok</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="showHide.conditions" width="70%">
      <v-card>
        <v-card-title class="title">Conditions</v-card-title>
        <v-card-text>{{ content.conditions }}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text color="blue" @click="showHide.conditions = false"
            >Ok</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-main>
</template>
<script>
/* eslint-disable */
import controller from "./auth.controller";

import firebase from "firebase/app";

export default {
  name: "Auth",
  route: {
    path: "/auth",
    name: "Auth",
  },
  mixins: [controller],
  data() {
    const defaultAuthForm = Object.freeze({
      First_Name: "",
      Last_Name: "",
      Email: "",
      Password: "",
      Confirm_Password: "",
      Terms: false,
    });
    return {
      locale: "en",
      authForm: Object.assign({}, defaultAuthForm),
      defaultAuthForm,
      rules: {
        name: [(val) => (val || "").length > 0 || "This field is required"],
        email: [
          /* eslint-disable */
          (val) => !!val || "E-mail is required",
          (val) =>
            /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
              val
            ) || "Invalid Email address",
          /* eslint-enable */
        ],
        password: [
          (val) =>
            (val || "") == this.authForm.Password || "Passwords Don't Match",
        ],
      },
      content: {
        terms: `Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer nec odio. Praesent libero. Sed cursus ante dapibus diam. Sed nisi. Nulla quis sem at nibh elementum imperdiet. Duis sagittis ipsum. Praesent mauris. Fusce nec tellus sed augue semper porta. Mauris massa. Vestibulum lacinia arcu eget nulla. `,
        conditions: `Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. Curabitur sodales ligula in libero. Sed dignissim lacinia nunc`,
      },
      showHide: {
        conditions: false,
        terms: false,
        password: String,
      },
      active_form: 0,
      forms: [
        {
          name: "SIGN-IN",
          show: {
            Email: true,
            Password: true,
            Create_Account: true,
            Forgot_Password: true,
          },
        },
        {
          name: "REGISTER",
          show: {
            First_Name: true,
            Last_Name: true,
            Email: true,
            Password: true,
            Confirm_Password: true,
            Terms: true,
          },
        },
        {
          name: "RESET PASSWORD",
          show: { Email: true, Reset_Email_Message: true },
        },
      ],
    };
  },
  computed: {
    signInIsValid() {
      return this.authForm.Email && this.authForm.Password;
    },
    registrationIsValid() {
      return (
        this.authForm.First_Name &&
        this.authForm.Last_Name &&
        this.authForm.Terms_Conditions
      );
    },
    resetPasswordIsValid() {
      return this.authForm.Email;
    },
  },
  watch: {
    locale(val) {
      this.$i18n.locale = val;
    },
  },
  methods: {
    showField(field) {
      // determines whether to show field based on active form
      let forms = this.forms;
      let activeForm = forms[this.active_form].show;
      return activeForm[field];
    },
    resetForm() {
      // TODO REMOVE window.wolftest
      window.wolftest = this.$refs.register;
      let forms = this.$refs.register;
      forms.forEach((form) => form.reset());
      this.register = Object.assign({}, this.defaultAuthForm);
      this.alert = Object.assign({}, this.defaultAlert);
      this.active_form = 0;
    },
    // showAlert(message) {
    //   let alert = this.alert;
    //   if (message == "success") {
    //     alert.type = "success";
    //     alert.show = true;
    //     alert.message = message;
    //   } else {
    //     alert.type = "error";
    //     alert.show = true;
    //     alert.message = message;
    //   }
    // },
    /* eslint-disable */
    submit() {
      //console.log("submit", e);
      this.resetForm();
    },
    onEnter(event) {
      if (event == "password" && this.signInIsValid && this.active_form == 0) {
        this._signIn(this.authForm); // used as mixin
      }
      console.log("on enter", this.forms[this.active_form].name, event);
    },
    checkUser() {
      console.log("auth/index.vue checkuser");
      var user = firebase.auth().currentUser;
      if (user) {
        // User is signed in.
        this.$router.push("/");
      } else {
        // No user is signed in.
      }
    },
  },
  mounted() {
    const user = firebase.auth().currentUser;
    let currentRoute = this.$router.currentRoute.path;
    if (user) {
      // User is signed in.
      this.$router.push("/");
    }
    this.resetForm();
  },
  i18n: {
    messages: {
      en: {
        register: "REGISTER",

        "auth/invalid": "Please check email address",
        "auth/user-disabled": "Sorry this user is disabled",
        "auth/user-not-found": "No user found :(",
        "auth/wrong-password":
          "There was an issue with your password.  You can reset or try again.",
        success: "Logged In! You will now be redirected to main page.",
        "Please enter your email address and a reset password link will be sent to you.":
          "Please enter your email address and a reset password link will be sent to you.",
      },
      fr: {
        register: "S'INSCRIRE",
        "SIGN IN": "SE CONNECTER",
      },
    },
  },
};
</script>
<style>
.v-tabs-bar {
  height: 0px;
}
.center-center {
  display: flex;
  min-height: 85vh;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.center-input input {
  text-align: center;
}
</style>
